import { render, staticRenderFns } from "./pageActions.vue?vue&type=template&id=0f365358&"
import script from "./pageActions.vue?vue&type=script&lang=js&"
export * from "./pageActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports